'use strict';

/*global initialize*/
/*global services*/
/*global isEmpty*/
/*global blockElement*/
/*global unBlockElement*/
/*global createObjectCallBack*/

(function ($) {
  function FormCommandsMenu($form, $container) {
    this.$container = $container;
    this.$commandsWrapper = null;
    this.formId = $form.attr('id');
    this.$form = $form;
    this.init();
  }

  FormCommandsMenu.prototype = $.extend({}, {
    constructor: 'FormCommandsMenu',

    registerCallbacks: function registerCallbacks() {
      var _this = this;

      _this.$container.on('click', '.use-filter', function () {
        _this.useFilter($(this).closest('.filter'));

        return false;
      });

      _this.$container.on('click', '.add-filter', function () {
        _this.editFilter();

        return false;
      });

      _this.$container.on('click', '.edit-filter', function () {
        _this.editFilter($(this).closest('.filter'));

        return false;
      });

      _this.$container.on('click', '.remove-filter', function () {
        _this.removeFilter($(this).closest('.filter'));

        return false;
      });

      _this.$container.on('mouseenter', function () {
        _this.loadCommandsMenu();

        return false;
      });
    },

    //----------------------------------------------------------------------------

    doEditFilter: function () {
      var _this = this;

      var modal = services.get('modal');
      var $content = modal.contentDOM();
      var $form = $content.find('form');
      $form.find('.filter-data').val(_this.$form.serialize());
      $form.find('.filter-prefix').val(_this.$form.data('prefix'));

      modal.block();
      $.post($form.attr('action'), $form.serialize(), function (res) {
        modal.unBlock();

        if (res.msg === 'SUCCESS') {
          modal.close();
          services.get('notifications').viewSaveMessage();

          _this.loadCommandsMenu(true);
        } else if (res.msg === 'NOT_VALID') {
          modal.content(res.data.html);
        } else {
          services.get('notifications').viewErrorMessage(res.error);
        }
      });

      return _this;
    },

    editFilter: function ($filter) {
      var _this = this;

      var modal = services.get('modal');
      modal.empty().open({
        title: services.get('translator').trans('filter.save'),
        height: 'auto',
        width: 'md',
        minHeight: '150px',
        submitCallBack: createObjectCallBack(_this, 'doEditFilter'),
        enterSubmitCallBack: createObjectCallBack(_this, 'doEditFilter'),
        form: true,
        keyboardClose: false
      });

      modal.block();
      $.get(services.get('router').path('form_commands_edit_filter', { formId: _this.formId }), $filter ? { filterId: $filter.data('id') } : {}, function (res) {
        modal.unBlock();
        if (res.msg === 'SUCCESS') {
          modal.content(res.data.html);
          initialize(modal.contentDOM());
        } else {
          services.get('notifications').viewErrorMessage();
        }
      });

      return _this;
    },

    removeFilter: function ($filter) {
      var _this = this;

      blockElement(_this.$commandsWrapper);
      $.get(services.get('router').path('form_commands_remove_filter', { formId: _this.formId, filterId: $filter.data('id') }), function (res) {
        unBlockElement(_this.$commandsWrapper);

        if (res.msg === 'SUCCESS') {
          _this.loadCommandsMenu(true);
        } else {
          services.get('notifications').viewErrorMessage();
        }

        initialize(_this.$commandsWrapper);
      });

      return _this;
    },

    useFilter: function ($filter) {
      var _this = this;

      _this.$form.k2_deserialize($filter.data('filter'));
      _this.$form.find('button[type="submit"]:first').click();

      return _this;
    },

    loadCommandsMenu: function (forceLoad) {
      var _this = this;

      if (isEmpty(_this.$commandsWrapper.html()) || forceLoad) {
        blockElement(_this.$container);
        $.get(services.get('router').path('form_commands_load_menu', { formId: _this.formId }), { filterPrefix: _this.$form.data('prefix') }, function (res) {
          unBlockElement(_this.$container);
          _this.$commandsWrapper.html(res.data.html);

          initialize(_this.$commandsWrapper);
        });
      }

      return _this;
    },

    //----------------------------------------------------------------------------

    init: function () {
      var _this = this;

      _this.$commandsWrapper = $('<div>', { class: 'form-commands-wrapper open' });
      _this.$container.append(_this.$commandsWrapper);

      _this.registerCallbacks();

      return _this;
    }
  });

  var methods = {
    init: function (/*options*/) {
      // options are not used
      //var opts = $.extend({}, $.fn.k2_form_commands_menu.defaults, options);
      return this.each(function () {
        var $this = $(this);

        if ($this.hasClass('form-commands-menu-init')) {
          return;
        }

        $this.addClass('form-commands-menu-init');
        $this.data('form-commands-menu', new FormCommandsMenu($this.closest('form'), $this));
      });
    }
  };

  $.fn.k2_form_commands_menu = function (methodOrOptions) {
    if (methods[methodOrOptions]) {
      return methods[methodOrOptions].apply(this, Array.prototype.slice.call(arguments, 1));
    } else if (typeof methodOrOptions === 'object' || !methodOrOptions) {
      return methods.init.apply(this, arguments);
    } else {
      $.error('Method ' + methodOrOptions + ' does not exists on jQuery.k2_form_commands_menu');
    }

  };

  $.fn.k2_form_commands_menu.defaults = {};

})(jQuery);
